export const TEAMS_PATH = '/teams';
export const TEAMS_ADD_PATH = '/teams/add';
export const TEAMS_EDIT_PATH = '/teams/:teamId/edit';
